import { useEffect } from 'react';
import './GlobalStyles.scss';

function GlobalStyles({ children }) {
    useEffect(() => {}, []);

    return children;
}

export default GlobalStyles;
